import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-standard-progress-bar',
  templateUrl: './standard-progress-bar.component.html',
  styleUrls: ['./standard-progress-bar.component.scss']
})
export class StandardProgressBarComponent implements OnInit {
  @Input() percent: number = 0;
  @Input() hidePercent: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
